import { createContext, type ReactNode, useContext } from 'react';

export interface ChatUser {
  tenantSlug?: string;
  roles?: string[];
}

const ChatUserContext = createContext<ChatUser>({});

export function ChatUserProvider({ user, children }: { user: ChatUser; children: ReactNode }) {
  return <ChatUserContext.Provider value={user}>{children}</ChatUserContext.Provider>;
}

export function useChatUser(): ChatUser {
  return useContext(ChatUserContext);
}
